import { jsx as _jsx } from "react/jsx-runtime";
import { MuiThemeProvider } from '@material-ui/core';
import { modernV4 } from '../themes';
export default (Component) => {
    function WrappedComponent(props) {
        return (_jsx(MuiThemeProvider, { theme: modernV4, children: _jsx(Component, Object.assign({}, props)) }));
    }
    return WrappedComponent;
};
